import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-modal-acciones-empresa',
  templateUrl: './modal-acciones-empresa.component.html',
  styleUrls: ['./modal-acciones-empresa.component.scss']
})
export class ModalAccionesEmpresaComponent implements OnInit {

  usuario=null;
  procesodeEliminarActivo=false
  procesodeEditarActivo=false
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''
  trabajando=false
  botondisabled=true


  nombre=''
  dominio=''
  responsable=''

  constructor(public activeModal: NgbActiveModal, private functions: AngularFireFunctions) { }

  ngOnInit(): void {
    this.nombre=this.usuario.data().nombre;
    this.dominio=this.usuario.data().dominio;
    this.responsable=this.usuario.data().responsable;
  }


  cerrar(parametro){
    this.activeModal.close(parametro);//esto no lo estamos usando pero es para tenerlo ahi 
  }

  confirmaEliminar(){
    this.procesodeEliminarActivo=true
  }
  cancelarEliminar(){
    this.procesodeEliminarActivo=false
  }

  confirmaUpdate(){
    this.procesodeEditarActivo=true
  }
  cancelaUpdate(){
    this.procesodeEditarActivo=false
  }


  eliminarEmpresa(idParaEliminar){

    this.trabajando=true
    this.alerta("warning","eliminando empresa...")

    firebase.firestore().collection("empresas").doc(idParaEliminar).delete().then(()=>{
      this.procesodeEliminarActivo=false
      this.alerta("success","¡Autoridad eliminada con éxito!")
      this.cerrar("OK")
    }).catch((err)=>{
      this.alerta("danger",err)
      this.cerrar(err)
    })

  }


  update(id){
    firebase.firestore().collection("empresas").doc(id).update({

      nombre:this.nombre,
      dominio:this.dominio,
      responsable:this.responsable,

    }).then(()=>{
      this.procesodeEditarActivo=false
      this.alerta("success","¡Autoridad editada con éxito!")
      this.cerrar("OK")
    }).catch((err)=>{
      this.procesodeEditarActivo=false
      this.alerta("danger",err)
      this.cerrar("OK")
    })
  }

  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }
  
  
  closeAlert(){
    this.alertaActiva=false
  }

  validaboton(){
    console.log("validaboton activado")
      if( this.nombre !='' && this.dominio !='' && this.responsable !=''){this.botondisabled=false}else
      if( this.nombre =='' || this.dominio =='' || this.responsable ==''){this.botondisabled=true}
  }



}//fin de clase

